import React from 'react';
import { baseColorData } from '~base-theme';
import Container from './Container';
import DashContainer from './DashContainer';
import Dash from './Dash';
import LoaderMessage from './LoaderMessage';

var Loader = function Loader(_ref) {
  var label = _ref.label,
      skin = _ref.skin,
      isFullScreen = _ref.isFullScreen,
      fullScreenBackgroundColor = _ref.fullScreenBackgroundColor,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(Container, {
    isFullScreen: isFullScreen,
    size: size,
    backgroundColor: fullScreenBackgroundColor
  }, /*#__PURE__*/React.createElement(DashContainer, {
    skin: skin,
    isFullScreen: isFullScreen
  }, /*#__PURE__*/React.createElement(Dash, {
    skin: skin
  })), label && /*#__PURE__*/React.createElement(LoaderMessage, {
    color: "muted"
  }, label));
};

Loader.defaultProps = {
  label: undefined,
  isFullScreen: false,
  skin: undefined,
  size: undefined,
  fullScreenBackgroundColor: undefined
};
export default Loader;